/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Serializer for the TherapistProfile model containing only minimal fields.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface TherapistProfileSerializerMinimal { 
    readonly id: number;
    readonly name: string;
    readonly appointmentResourceId: number | null;
}
export const TherapistProfileSerializerMinimal_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TherapistProfileSerializerMinimal_name_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TherapistProfileSerializerMinimal_appointmentResourceId_Validators: ValidatorFn[] =
    [  Validators.required, ];


